module.exports = __webpack_public_path__ + "img/travel-agency__lighthouse.be96e4af.jpg";